import React from 'react'
import { useNavigate } from 'react-router-dom'
import GardenDailyWorkCard from './GardenDailyWork'
import { Pie } from 'react-chartjs-2'
import { Pieoptions } from '../../../../../Helper/Data'

export default function GardenDailyWorkCardManage(props) {

    const { Countdata, HeaderMonthID, HeaderFinancialYear, MonthValue, YearValue, YearLabel, MonthLabel, WardValue, WardLabel, ProjectTypeId, DashboardName } = props
    const navigate = useNavigate()

    const DailyPreventiveWorkNavigate = (name, screenFlag) => {
        if (name === "Pending") {
            navigate(`/gardenworkpending?name=${name}&ApiFlag=Pending&Year=${YearValue}&YLable=${YearLabel}&Month=${MonthValue}&MLable=${MonthLabel}&WardName=${WardValue}&WLable=${WardLabel}&ProjectTypeId=${ProjectTypeId}&DashboardName=${DashboardName}`)
        } else if (name === "Completed") {
            navigate(`/gardenworkpending?name=${name}&ApiFlag=Completed&Year=${YearValue}&YLable=${YearLabel}&Month=${MonthValue}&MLable=${MonthLabel}&WardName=${WardValue}&WLable=${WardLabel}&ProjectTypeId=${ProjectTypeId}&DashboardName=${DashboardName}`)
        }
    }

    const Receiveddata = {
        labels: ["Pending", "Completed",],
        datasets: [
            {
                label: '# of Votes',
                data: [
                    Countdata && Countdata?.PreventivePendingTotalCount,
                    Countdata && Countdata?.PreventiveCompletedTotalCount
                    // 50,20
                ],
                backgroundColor: [
                    "#ffc33d",
                    "#f48242"
                ],
                borderColor: [
                    // '#28c8c1',
                    // '#172b4d',
                    // '#993366',
                    // '#593e89',
                    // '#94408e',
                    // '#c74382',
                    // '#fa5d00',
                    // '#529ad2',
                    // '#ffc137',
                ],
                borderWidth: 1,
            },
        ],
    };

    return (
        // <>
            
        // </>
        <div className='row m-1 p-0  bg-white' style={{ border: '1px solid #0d467ee6', borderRadius: '8px ' }}>

            <h5 className=" py-2 mb-0 border5">Daily Preventive Work</h5>

            <div className="row pt-3 pb-2 ps-3" >

                <div className="col-12 col-md-6 col-lg-3 " >
                    <GardenDailyWorkCard
                        title="Pending"
                        cardName='py-2 wwork_img cursor'
                        imgPath='./assets/img/pending.png'
                        count={Countdata.PreventivePendingTotalCount ? Countdata.PreventivePendingTotalCount : '0'}
                  
                        DailyPreventiveWorkNavigate={DailyPreventiveWorkNavigate}
                    />
                </div>

                <div className="col-12 col-md-6 col-lg-3 ">
                    <GardenDailyWorkCard
                        title="Completed"
                        cardName='py-2 wwork_img cursor'
                        imgPath='./assets/img/completed1.png'
                        count={Countdata.PreventiveCompletedTotalCount ? Countdata.PreventiveCompletedTotalCount : '0'}
                       
                        DailyPreventiveWorkNavigate={DailyPreventiveWorkNavigate}
                    />
                </div>

                <div className="col-12 col-lg-5">
                    <div className="px-3 pb-0 upload_chart ">
                        <div className="row d-flex justify-content-center align-items-center ">
                            {
                                (Countdata?.PreventivePendingTotalCount != 0) || (Countdata?.PreventiveCompletedTotalCount != 0) ?
                                    <Pie
                                        height={10}
                                        options={Pieoptions}
                                        data={Receiveddata}
                                    />
                                    :
                                    <div className='text-danger text-center fw-bolder'>
                                        No Data Found
                                    </div>
                            }
                        </div>
                    </div>
                </div>

            </div>

        </div>
    )

}

